<template slot-scope="scope">
    考试列表
    <el-scrollbar max-height="600px">


    <div class="demo-collapse">
      <el-collapse v-model="activeNames">
          <el-collapse-item :title="homework.examName + ' （时间：' + homework.startTime + '~' + homework.stopTime +'）'" :name="homework.examId" v-for="homework in homeworks" :key="homework.examId">

            <el-button type="success" class="addBtn" @click="gotoProblem(homework.examId);" plain>
                查看试卷
            </el-button>

            <el-button type="primary" class="addBtn" plain>
                考试时长: {{ homework.examTime }}min
            </el-button>

            <el-button type="primary" class="addBtn" plain>
                总分: {{ homework.score }}
            </el-button>

            <el-button type="warning" class="addBtn" v-if="homework.examRecord && homework.examRecord.score != null" plain>
                得分: {{ homework.examRecord.score }}
            </el-button>

            <el-button type="danger" class="addBtn" v-if="homework.examRecord && homework.examRecord.score == null" plain>
                未批阅
            </el-button>
          </el-collapse-item>    
      </el-collapse>
      </div>
    </el-scrollbar>
  </template>
  
  <script setup>
  import { ref, onMounted } from "vue";
  import $ from "jquery";
  import { useRoute } from "vue-router";
  import { ElMessage } from 'element-plus';

  import { useStore } from 'vuex';
const store = useStore();

  
  const Route = useRoute(); //获取到值
  const courseId = ref("");
  
  const homeworks = ref([]);
  const course = ref();

  
  
  onMounted(() => {
    courseId.value = Route.params.courseId;
    pullExam();
    pullCourse();
  });
  
  
  const pullExam = () => {
      const token = localStorage.getItem("token");
      $.ajax({
          url: "http://124.222.105.205:5000/api/exam/PullExam",
          data: {
              courseId: courseId.value,
              type: 1
          },
          type: "post",
          headers: {
              Authorization: "Bearer " + token,
          },
          success(resp) {
              if (resp.code == "200") {
                console.log(resp.data);
                for(let homework of resp.data) {
                    if (homework.states != 0)
                    homeworks.value.push(homework);
                }
                 // homeworks.value = resp.data;
              }
              if (resp.code != "200") {
                  ElMessage({
                      type: "error",
                      message: resp.msg,
                  });
              }
              console.log(resp.data);
          },
          error() {
              ElMessage({
                  type: "error",
                  message: "拉取试卷失败",
              });
          },
      });
  }
  
  const pullCourse = () => {
    $.ajax({
    url: "http://124.222.105.205:5000/get/api/course/getCourseById",
    data: {
        courseId: courseId.value
    },
    type: "post",
    success(resp) {
      course.value = resp.data;

      if (resp.code != "200") {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }
    },
    error() {
        ElMessage({
          type: "error",
          message: "获取课程失败",
        });
    },
  });
}
  
  const gotoProblem = (id) => {

    if (course.value.createId == store.state.user.id) {
        const a = document.createElement('a');
        a.href = `/ProblemSetting/${id}/${courseId.value}/`; // 假设课程详情页面的路由是/course/:courseId
        a.target = '_blank'; // 在新页面中打开
        a.click(); // 触发点击事件
    } else {
        const a = document.createElement('a');
        a.href = `/LearnExam/${id}/${courseId.value}/`; // 假设课程详情页面的路由是/course/:courseId
        a.target = '_blank'; // 在新页面中打开
        a.click(); // 触发点击事件
    }
    
  }
  
  </script>
  
  <style scoped>
  
  .addBtn {
      float: right;
      margin: 0px 5px;
  }
  
  </style>